<template>

    <div class="content-load" style="overflow-y: hidden; height: auto; background: #fff !important;">

        <img src="static/images/logo.png" style="width: 100%; height: 100px; object-fit: contain; margin: 30px auto;">

        <div v-if="detalhes" v-html="detalhes.conteudo">
           
        </div>

    </div>
</template>

<script>
export default {
    name:                           'Contrato',
    components: {
    },
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
        },          
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "detalhes":             null,
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
            },
        }
    },  
    methods: {   
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/contratos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.detalhes               = response.data.result;

                    self.loaded             = true;
                    self.$forceUpdate();
                    loading.hide();
                    setTimeout(function() {
                        window.print()
                    }, 100);

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },        
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
    },
    activated: function() {
        var self = this;
        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }
        loading.show();
        self.form.cod = self.$route.query.c;
        self.get();        
    },    

}
</script>

<style scoped>
    
    @page {
        size: A4;
        padding: 50px !important;    
    }


    @media print {

        html, body {
            width: 210mm;
            height: 297mm;
        }
      /* ... the rest of the rules ... */
    }

</style>



// WEBPACK FOOTER //
// src/components/Contrato.vue